/* eslint-disable dot-notation */
import { Validators } from '@angular/forms';
import { Role } from '../../../enums/role.enum';
import {
  formField,
  formModel,
} from '../../../utilities/form-mapper/annotations';

@formModel()
export class UserModelForm {
  @formField({ validators: Validators.required })
  public badgeNumber!: string | null;

  @formField({ validators: Validators.required })
  public firstName!: string | null;

  @formField({ validators: Validators.required })
  public lastName!: string | null;

  @formField({ validators: Validators.required })
  public email!: string | null;

  @formField({ validators: Validators.required })
  public level!: string | null;

  @formField({ validators: Validators.required })
  public role!: Role | null;

  @formField({ validators: Validators.required })
  public title!: string | null;

  @formField({ validators: Validators.required })
  public enabled!: boolean | null;
}
